import React, { useRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { usePopoverBehavior } from '../shared';
import { BeakWrapper, getThemeConfig, PopoverPane, PopoverWrapper } from '../styles';

var Beak = function Beak() {
  var clipPathId = "path-".concat(Date.now());
  var clipPathIdUrl = "url(#".concat(clipPathId, ")");
  var filterId = "filter-".concat(Date.now());
  var filterUrl = "url(#".concat(filterId, ")");
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "32",
    viewBox: "0 0 48 32",
    role: "presentation",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: clipPathIdUrl
  }, /*#__PURE__*/React.createElement("g", {
    filter: filterUrl
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3359 21.5039L8.8906 1.3359C8.3342 0.501303 7.39751 0 6.39445 0H41.6056C40.6025 0 39.6658 0.501303 39.1094 1.3359L25.6641 21.5038C24.8725 22.6913 23.1275 22.6913 22.3359 21.5039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0C3.72386 0 3.5 0.223858 3.5 0.5C3.5 0.776142 3.72386 1 4 1V0ZM9.18747 2.2812L9.60349 2.00385V2.00385L9.18747 2.2812ZM21.5038 20.7558L21.0878 21.0331L21.5038 20.7558ZM26.4962 20.7558L26.0801 20.4784L26.4962 20.7558ZM38.8125 2.2812L38.3965 2.00385L38.8125 2.2812ZM44 1C44.2761 1 44.5 0.776142 44.5 0.5C44.5 0.223858 44.2761 0 44 0V1ZM4 1H5.85926V0H4V1ZM8.77144 2.55855L21.0878 21.0331L21.9199 20.4784L9.60349 2.00385L8.77144 2.55855ZM26.9122 21.0331L39.2286 2.55855L38.3965 2.00385L26.0801 20.4784L26.9122 21.0331ZM42.1407 1H44V0H42.1407V1ZM39.2286 2.55855C39.8777 1.58485 40.9705 1 42.1407 1V0C40.6361 0 39.2311 0.751954 38.3965 2.00385L39.2286 2.55855ZM21.0878 21.0331C22.4732 23.1112 25.5268 23.1112 26.9122 21.0331L26.0801 20.4784C25.0906 21.9628 22.9094 21.9628 21.9199 20.4784L21.0878 21.0331ZM5.85926 1C7.0295 1 8.12231 1.58485 8.77144 2.55855L9.60349 2.00385C8.7689 0.751955 7.36385 0 5.85926 0V1Z",
    fill: "#CAC8D1"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: filterId,
    x: "-6",
    y: "-4",
    width: "60",
    height: "37",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: "2",
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_15783_139890"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0588235 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15783_139890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15783_139890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    width: "48",
    height: "32",
    fill: "white"
  }))));
};

var Popover = function Popover(_ref) {
  var ariaLabel = _ref['aria-label'],
      dataTest = _ref['data-test'],
      children = _ref.children,
      className = _ref.className,
      _ref$closeOnPaneClick = _ref.closeOnPaneClick,
      closeOnPaneClick = _ref$closeOnPaneClick === void 0 ? true : _ref$closeOnPaneClick,
      onPopoverStateChange = _ref.onPopoverStateChange,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      _ref$showBeak = _ref.showBeak,
      showBeak = _ref$showBeak === void 0 ? false : _ref$showBeak,
      targetElement = _ref.targetElement,
      theme = _ref.theme,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '320px' : _ref$width;
  var popoverPaneRef = useRef(null);

  var _usePopoverBehavior = usePopoverBehavior(targetElement, onPopoverStateChange, closeOnPaneClick ? null : popoverPaneRef),
      isPopoverShown = _usePopoverBehavior.isPopoverShown,
      extendedTargetElement = _usePopoverBehavior.extendedTargetElement,
      wrapperRef = _usePopoverBehavior.wrapperRef;

  var componentTheme = useComponentTheme({
    name: 'Popover',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(PopoverWrapper, {
    className: className,
    "data-test": dataTest ? "".concat(dataTest, "-wrapper") : undefined,
    ref: wrapperRef
  }, extendedTargetElement, /*#__PURE__*/React.createElement(PopoverPane, {
    "aria-label": ariaLabel,
    "aria-labelledby": extendedTargetElement.props.id,
    customTheme: componentTheme,
    "data-test": dataTest ? dataTest : undefined,
    isShown: isPopoverShown,
    position: position,
    ref: popoverPaneRef,
    role: "region",
    showBeak: showBeak,
    width: width
  }, showBeak && /*#__PURE__*/React.createElement(BeakWrapper, {
    position: position
  }, /*#__PURE__*/React.createElement(Beak, null)), children));
};

export default Popover;